export default "__VITE_PUBLIC_ASSET__ce1ceada__"